<template>
  <div class="person-card" @click="handleCardClick">
    <div class="left" v-if="consultStatus !== 'consultant'">
      <img class="left-img" :src="cardItem.headPicUrl" />
      <div class="status" v-if="personalStatus">
        {{ personalStatus }}
      </div>
      <img class="icon" src="/img/man.png" v-if="cardItem.gender === 1" />
      <img class="icon" src="/img/hed.png" v-else />
      <div class="name" :class="{top: personalStatus}">{{ cardItem.nickName }}</div>
    </div>
    <div class="content">
      <div class="container">
        <div class="center">
          <div class="personal" v-if="consultStatus === 'consultant'">
            <img src="/img/icon-personal.png" alt="" />
            <span>
              {{ cardItem.consultUserName }}
            </span>
          </div>
          <div class="top" v-if="consultStatus !== 'consultant'">
            <div
              v-if="cardItem.workedFamousCompanyList && cardItem.workedFamousCompanyList.length > 0"
              class="company-list"
            >
              <div
                class="company-name"
                v-for="(item, index) in cardItem.workedFamousCompanyList"
                :key="`company-${index}-${item}`"
              >
                {{ item }}
              </div>
            </div>

            <div class="year">
              {{ cardItem.occupationName }}<span v-if="cardItem.workYears"> · {{ cardItem.workYears }}年</span>
            </div>
            <div class="location">
              <!-- <span class="loc-name"> -->
              <img src="/img/loc-icon.png" alt="" class="loc-img" />
              <!-- </span> -->
              <!-- <i class="el-icon-location-outline"></i> -->
              <div class="loc-name">
                {{ areaNameFromList }}
              </div>
              <div class="loc-name name-user" v-if="consultStatus === 'all'">
                （预约人: {{ cardItem.consultUserName }}）
              </div>
            </div>
          </div>
          <!-- 我的预约 -->
          <template v-if="consultStatus === 'consulter' || consultStatus === 'all'">
            <div class="consultant-content">
              <div class="icon">{{ appointmentStatus }}</div>
              <div class="time">
                <img src="/img/clock-active.png" alt="" />
                <span class="time-start">{{ cardItem.appointmentStartTime }}</span>
                <span class="long">{{ formatDuration(cardItem.consultDuration) }}</span>
              </div>
            </div>
          </template>
          <!-- 预约我的 -->
          <template v-else-if="consultStatus === 'consultant'">
            <div class="consultant-content my">
              <div class="icon">{{ appointmentStatus }}</div>
              <div class="time">
                <img src="/img/clock-active.png" alt="" />
                <span class="time-start">{{ cardItem.appointmentStartTime }}</span>
                <span class="long">{{ formatDuration(cardItem.consultDuration) }}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <!-- 擅长知识 -->
            <div class="tag-content" v-if="cardItem.knowledgeList && cardItem.knowledgeList.length > 0">
              <div
                class="tag"
                v-for="(item, index) in cardItem.knowledgeList.slice(0, 6)"
                :key="`knowledge-${index}-${item}`"
              >
                {{ truncateKnowledge(item) }}
              </div>
            </div>
            <div class="description" v-if="cardItem.introduction">{{ cardItem.introduction }}</div>
          </template>
          <!-- 我的预约，只展示标题 -->
        </div>
        <!-- 预约按钮， -->
        <div class="right-btn" v-if="canShowAppointmentButton">
          <div class="btn-top" @click.stop="appointmentOpen">预约</div>
          <div class="btn-bottom">
            <div class="coll">
              <img src="" alt="" />
            </div>
            <div class="add"></div>
          </div>
        </div>
        <template v-if="consultStatus === 'consultant' || consultStatus === 'consulter' || consultStatus === 'all'">
          <div class="btn-top" :class="getEnterButtonClass()" @click.stop="enterConsulting">
            进入
          </div>
        </template>
      </div>

      <div class="bottom" :class="{my: consultStatus === 'consultant'}">
        <div
          class="price"
          v-if="consultStatus === 'consultant' || consultStatus === 'consulter' || consultStatus === 'all'"
        >
          ￥{{ cardItem.appointmentPayPrice }}
        </div>
        <template v-else>
          <div class="price" v-if="cardItem.discountPrice">￥{{ cardItem.discountPrice }}/h</div>
          <div class="dis-price" v-if="cardItem.hasDiscount">￥{{ cardItem.originalPrice }}/h</div>
        </template>
        <template v-if="consultStatus === '' || consultStatus === 'col'">
          <div class="star">
            <custom-rate
              v-if="cardItem.evaluationScore"
              :value="cardItem.evaluationScore"
              :disabled="true"
              :show-score="false"
              :max="5"
            ></custom-rate>
            <div class="score">
              <span v-if="cardItem.evaluationScore"> {{ cardItem.evaluationScore }}分</span
              ><span v-if="cardItem.evaluationScore && cardItem.orderNum">/</span
              ><span v-if="cardItem.orderNum">{{ cardItem.orderNum }}单</span>
            </div>
          </div>
          <div class="btn-container">
            <div class="collect-content" @click.stop="handleCollect" :class="{loading: collectLoading}">
              <img class="collect-img" v-if="cardItem.collectionFlag" src="/img/star-active.png" />
              <img class="collect-img" v-else src="/img/star.png" />
              <i v-if="collectLoading" class="el-icon-loading"></i>
            </div>
            <div class="follow" @click.stop="handleFollow" :class="{loading: followLoading}">
              <img class="follow-img" src="/img/guanzhu-active.png" v-if="cardItem.followedFlag" />
              <img class="follow-img" src="/img/coll.png" v-else />
              <i v-if="followLoading" class="el-icon-loading"></i>
            </div>
          </div>
        </template>
        <template
          v-else-if="
            (consultStatus === 'consultant' || consultStatus === 'consulter' || consultStatus === 'all') &&
              appointmentStatus !== '已取消'
          "
        >
          <div class="end-time" v-if="countdown">距离开始还剩：{{ countdown }}</div>
          <!-- <div class="enter-consulting-btn" :class="{disabled: !canEnterConsulting}" @click.stop="enterConsulting">
            进入咨询室
          </div> -->
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// import { getEmployeeListApi } from '../../api/personal'

import {mapState} from 'vuex'
import {checkedDeepFormat} from '../../utils/findQueryName'
import {toggleFollow, cancelFollow, toggleCollection, deleteCollection} from '@/api/consultingService'
import CustomRate from '@/components/custom-rate.vue'
const status = {
  0: '休息中',
  2: '已下线'
}

const appointmentObj = {
  0: '待接受',
  1: '待开始',
  2: '进行中',
  3: '已完成',
  4: '已拒绝',
  5: '已取消'
}
export default {
  name: 'personalCard',
  components: {
    CustomRate
  },
  props: {
    cardItem: {
      type: Object,
      default: () => {}
    },
    consultStatus: {
      type: String,
      default: 'consultser'
    }
  },
  computed: {
    ...mapState([
      'UserInfo',
      'AreaList',
      'BusinessList',
      'CompanyList',
      'EmployeeDomainList',
      'EducationList',
      'EmployeeOccupationList',
      'EmployeeDomainClassList',
      'EmployeeOccupationDomainClassRelationList',
      'SearchInput',
      'FamousInternetCompanyShortNameList'
    ]),
    personalStatus() {
      return status[this.cardItem.status] || ''
    },
    area_list() {
      return checkedDeepFormat(this.AreaList) || {}
    },
    appointmentStatus() {
      return appointmentObj[this.cardItem.appointmentStatus] || ''
    },
    // 从 areaList 中提取地址名称
    areaNameFromList() {
      if (!this.cardItem.areaList || !Array.isArray(this.cardItem.areaList) || this.cardItem.areaList.length === 0) {
        return this.cardItem.areaName || ''
      }

      // 提取所有区域的 name 字段
      const names = this.cardItem.areaList.map(item => item.name).filter(name => name)

      if (names.length === 0) {
        return this.cardItem.areaName || ''
      }

      // 如果只有一个元素，直接返回（直辖市情况）
      if (names.length === 1) {
        return names[0]
      }

      // 多个元素时，去重后连接（避免"北京 北京"的情况）
      const uniqueNames = [...new Set(names)]

      // 如果去重后只有一个，只返回一个（直辖市情况）
      if (uniqueNames.length === 1) {
        return uniqueNames[0]
      }

      // 多个不同名称，用空格连接（省份+城市情况）
      return uniqueNames.join(' ')
    },
    // 是否显示预约按钮
    canShowAppointmentButton() {
      if (this.consultStatus === 'consultant' || this.consultStatus === 'consulter' || this.consultStatus === 'all') {
        return false
      }
      // 如果状态不是"已上线"（status !== 1），则隐藏预约按钮
      if (this.cardItem.status !== 1) {
        return false
      }
      if (this.cardItem.currentConsultantUserFlag === 1) {
        return false
      }

      // 如果是承约人（currentConsultantUserFlag === 1）
      if (this.cardItem.currentConsultantUserFlag === 1) {
        // 如果承约人在营销中心开通了代买权限，则显示预约按钮
        return this.cardItem.currentManageOperatorFlag === 1
      }

      // 如果不是承约人，则显示预约按钮
      return true
    },
    // 是否可以进入咨询室（任何状态都可以进入，只是颜色不同）
    canEnterConsulting() {
      // 任何状态都可以进入咨询室
      return true
    }
  },
  data() {
    return {
      colorArr: ['#F9E48A'],
      followLoading: false,
      collectLoading: false,
      countdown: '', // 倒计时显示文本
      countdownTimer: null, // 倒计时定时器
      refreshTimer: null // 刷新列表定时器
    }
  },
  created() {
    // 只有在进行中，并且是我的预约，预约我的，全站预约，才展示倒计时
    let status = this.cardItem.appointmentStatus

    // 只有"待接受、待开始、进行中"状态显示青色，其他状态显示灰色
    const activeStatuses = [0, 1, 2] // 待接受、待开始、进行中
    if (activeStatuses.includes(status)) {
      this.startCountdown()
    }
  },
  beforeDestroy() {
    this.stopCountdown()
    this.clearRefreshTimer()
  },
  methods: {
    // 截取知识文本，超过5个字时显示前5个字+".."
    truncateKnowledge(text) {
      if (!text) return ''
      if (text.length <= 5) return text
      return text.substring(0, 5) + '..'
    },
    // 格式化时长显示
    formatDuration(minutes) {
      if (!minutes || minutes <= 0) {
        return '0分钟'
      }

      // 小于1小时，显示分钟
      if (minutes < 60) {
        return `${minutes}分钟`
      }

      // 计算小时数和剩余分钟数
      const hours = Math.floor(minutes / 60)
      const remainingMinutes = minutes % 60

      // 如果正好是整数小时（如60、120分钟），只显示小时
      if (remainingMinutes === 0) {
        return `${hours}小时`
      }

      // 如果有剩余分钟数，显示"x小时x分钟"
      return `${hours}小时${remainingMinutes}分钟`
    },

    // 计算倒计时
    calculateCountdown() {
      if (!this.cardItem.appointmentStartTime) {
        this.countdown = ''
        return
      }

      // 解析预约开始时间
      const appointmentTime = new Date(this.cardItem.appointmentStartTime.replace(' ', 'T'))
      // 使用浏览器当前时间
      const currentTime = new Date()
      // 计算时间差（毫秒）
      const timeDiff = appointmentTime.getTime() - currentTime.getTime()

      if (timeDiff <= 0) {
        this.countdown = ''
        return
      }

      // 计算总小时数
      const totalHours = Math.floor(timeDiff / (1000 * 60 * 60))

      // 如果超过24小时，不显示倒计时
      if (totalHours >= 24) {
        this.countdown = ''
        return
      }

      // 计算小时、分钟、秒（24小时内）
      const hours = totalHours
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000)

      // 格式化为 HH:MM:SS
      const formatNumber = num => String(num).padStart(2, '0')
      this.countdown = `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`
    },

    // 启动倒计时定时器
    startCountdown() {
      if (this.consultStatus === 'consultant' || this.consultStatus === 'consulter' || this.consultStatus === 'all') {
        this.calculateCountdown()
        this.countdownTimer = setInterval(() => {
          this.calculateCountdown()
        }, 1000) // 每秒更新一次倒计时

        // 每5秒刷新一次列表
        this.startRefreshTimer()
      }
    },

    // 启动刷新列表定时器
    startRefreshTimer() {
      // 先清除之前的定时器
      this.clearRefreshTimer()
      // 每5秒刷新一次列表
      this.refreshTimer = setInterval(() => {
        this.$emit('updateList')
      }, 10000)
    },

    // 清除刷新列表定时器
    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    },

    // 停止倒计时定时器
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
      // 同时清除刷新定时器
      this.clearRefreshTimer()
    },
    appointmentOpen() {
      this.$emit('appointmentOpen', {
        visiable: true,
        consultantId: this.cardItem.consultantId
      })
    },
    // 获取进入按钮样式类
    getEnterButtonClass() {
      let status = this.cardItem.appointmentStatus

      // 只有"待接受、待开始、进行中"状态显示青色，其他状态显示灰色
      const activeStatuses = [0, 1, 2] // 待接受、待开始、进行中
      if (!activeStatuses.includes(status)) {
        return 'disabled'
      }

      // 其他状态（已完成、已拒绝、已取消）都显示灰色
    },

    // 处理卡片点击
    handleCardClick() {
      // 如果是"预约我的"列表，点击进入咨询室
      if (this.consultStatus === 'consultant') {
        this.enterConsulting()
      } else {
        // 处理卡片点击
        this.handleItemClick()
      }
      // 其他情况不处理，保持原有逻辑
    },
    // 处理卡片点击
    handleItemClick() {
      this.$router.push(`/personalConsultDetail?consultant_id=${this.cardItem.consultantId}`)
    },

    // 进入咨询室
    enterConsulting() {
      this.$router.push(`/consultingRoom?appointmentId=${this.cardItem.appointmentId}`)
    },
    // 处理收藏
    async handleCollect() {
      // 未登陆
      if (!this.UserInfo || !this.UserInfo.id) {
        this.$router.push('/login')
        return
      }
      if (this.collectLoading) return

      this.collectLoading = true
      try {
        if (this.cardItem.collectionFlag) {
          // 取消收藏
          await deleteCollection({
            objectId: this.cardItem.consultantId,
            objectType: '咨询'
          })
          this.$set(this.cardItem, 'collectionFlag', 0)
          this.$message.success('取消收藏成功')
        } else {
          // 添加收藏
          await toggleCollection({
            objectId: this.cardItem.consultantId,
            objectType: '咨询'
          })
          this.$set(this.cardItem, 'collectionFlag', 1)
          this.$message.success('收藏成功')
        }
      } catch (error) {
        console.error('收藏操作失败:', error)
        // this.$message.error('操作失败，请重试')
      } finally {
        this.collectLoading = false
      }
    },

    // 处理关注
    async handleFollow() {
      if (!this.UserInfo || !this.UserInfo.id) {
        this.$router.push('/login')
        return
      }
      if (this.followLoading) return

      this.followLoading = true
      try {
        if (this.cardItem.followedFlag) {
          // 取消关注
          await cancelFollow({
            objectId: this.cardItem.employeeId,
            objectType: '咨询'
          })
          this.$set(this.cardItem, 'followedFlag', 0)
          this.$message.success('取消关注成功')
        } else {
          // 添加关注
          await toggleFollow({
            objectId: this.cardItem.employeeId,
            objectType: '咨询'
          })
          this.$set(this.cardItem, 'followedFlag', 1)
          this.$message.success('关注成功')
        }
      } catch (error) {
        console.error('关注操作失败:', error)
        // this.$message.error('操作失败，请重试')
      } finally {
        this.followLoading = false
      }
    }
  },
  watch: {
    // 监听 cardItem 变化，重新计算倒计时
    // cardItem: {
    //   handler() {
    //     this.calculateCountdown()
    //   },
    //   deep: true
    // },
    consultStatus: {
      handler(val) {
        if (val === 'consultant' || val === 'consulter' || val === 'all') {
          return
        }
        this.stopCountdown()
        this.clearRefreshTimer()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.person-card {
  width: 886px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
  padding: 24px 32px 27px 15px;
  display: flex;
  .name {
    left: 14px;
    margin-top: 4px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    width: 78px;
    position: relative;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.top {
      margin-top: 12px;
    }
  }

  .left {
    position: relative;

    &-img {
      width: 107px;
      height: 107px;
      border-radius: 0px 0px 0px 0px;
      border: 2px solid #acacac;
      border-radius: 50%;
    }

    .status {
      width: 88px;
      height: 35px;
      background: #f5f5f5;
      border-radius: 60px 60px 60px 60px;
      border: 1px solid #e6e6e6;
      position: relative;
      z-index: 10;
      margin-top: -33px;
      // top: 88px;
      left: 10px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      text-align: left;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icon {
      position: absolute;
      width: 20px;
      height: 20px;
      top: 0px;
      right: 8px;
    }
  }

  .content {
    // width: calc(100% - 120px);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .container {
      display: flex;
      position: relative;
      .center {
        width: 640px;
        width: 100%;

        .personal {
          display: flex;
          align-items: center;
          font-size: 18px;
          color: #333333;
          img {
            width: 21px;
            height: 21px;
            margin-right: 6px;
          }
        }
      }
    }
    .consultant-content {
      display: flex;
      align-items: center;
      margin-top: 17px;
      &.my {
        margin-left: 25px;
      }
      .icon {
        width: 86px;
        height: 29px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #5ad3cd;
        font-weight: 400;
        font-size: 18px;
        color: #5ad3cd;
        text-align: center;
        line-height: 29px;
      }
      .time {
        font-weight: bold;
        display: flex;
        align-items: center;
        margin-left: 12px;
        img {
          width: 24px;
          height: 24px;
        }
        .time-start {
          margin-left: 12px;
          margin-right: 14px;
        }
      }
    }

    margin-left: 24px;

    .top {
      display: flex;
      align-items: center;
      .company-list {
        display: flex;
      }

      .company-name {
        // width: 72px;
        height: 32px;
        background: rgba(255, 114, 76, 0.16);
        border-radius: 4px 4px 4px 4px;
        font-family: PingFang HK, PingFang HK;
        font-weight: 400;
        font-size: 20px;
        color: #ff724c;
        text-align: center;
        line-height: 32px;
        font-style: normal;
        text-transform: none;
        margin-right: 14px;
        padding: 0 10px;
      }

      .year {
        font-family: PingFang HK, PingFang HK;
        font-weight: 600;
        font-size: 20px;
        color: #333333;
      }

      .location {
        display: flex;
        align-items: center;
        margin-left: 14px;
        display: flex;
        .loc-img {
          width: 24px;
          height: 24px;
        }

        .loc-name {
          font-weight: 400;
          font-size: 18px;
          color: #999999;
          margin-left: 3px;
          &.name-user {
            color: #333333;
            // margin-left: px;
          }
        }
      }
    }

    .tag-content {
      display: flex;
      align-items: center;
      margin-top: 16px;
      width: 640px;
      overflow: hidden;
      white-space: nowrap;

      .tag {
        height: 36px;
        line-height: 36px;
        border-radius: 57px 57px 57px 57px;
        border: 1px solid #e6e6e6;
        text-align: center;
        box-sizing: border-box;
        padding: 0px 16px;
        margin-right: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 160px;
        flex-shrink: 0;
      }
    }

    .description {
      width: 555px;
      height: 25px;
      font-family: PingFang HK, PingFang HK;
      font-weight: 400;
      font-size: 18px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 17px;
    }

    .bottom {
      margin-top: 17px;
      display: flex;
      align-items: center;
      &.my {
        margin-left: 25px;
      }
      .price {
        font-family: PingFang HK, PingFang HK;
        font-weight: 600;
        font-size: 22px;
        color: #ff724c;
        margin-right: 24px;
      }

      .dis-price {
        font-family: PingFang HK, PingFang HK;
        font-weight: 600;
        font-size: 18px;
        color: #999999;
        text-align: left;
        font-style: normal;
        text-decoration-line: line-through;
        text-transform: none;
        margin-right: 24px;
      }

      .star {
        display: flex;
        align-items: center;
        gap: 10px;

        /deep/ .custom-rate {
          .star-icon {
            width: 28px;
            height: 28px;
          }
        }

        .score {
          font-family: PingFang HK, PingFang HK;
          font-weight: 600;
          font-size: 22px;
          color: #ff724c;
        }
      }
      .btn-container {
        display: flex;
        right: 10px;
        margin-left: auto;
        align-items: center;
        .collect-content {
          margin-right: 48px;
          position: relative;
          cursor: pointer;
          transition: opacity 0.3s;
          display: flex;
          align-items: center;

          &.loading {
            opacity: 0.6;
            pointer-events: none;
          }

          .el-icon-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 16px;
            color: #5ad3cd;
          }
        }
        .collect {
          &-img {
            width: 32px;
            height: 32px;
          }
        }
        .follow {
          position: relative;
          cursor: pointer;
          transition: opacity 0.3s;
          display: flex;
          align-items: center;

          &.loading {
            opacity: 0.6;
            pointer-events: none;
          }

          .el-icon-loading {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 16px;
            color: #5ad3cd;
          }

          &-img {
            width: 32px;
            height: 32px;
          }
        }
      }

      position: relative;
      .end-time {
        position: absolute;
        right: 19px;
      }
    }
    .enter-consulting-btn {
      // position: absolute;
      // right: 19px;
      // top: 30px;
      width: 100px;
      height: 35px;
      background: #5ad3cd;
      border-radius: 4px;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 35px;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        background: #4bc4be;
      }

      &.disabled {
        background: #cccccc;
        color: #999999;

        &:hover {
          background: #cccccc;
        }
      }
    }

    .btn-top {
      cursor: pointer;
      width: 68px;
      height: 35px;
      background: #5ad3cd;
      border-radius: 60px 60px 60px 60px;
      font-size: 18px;
      color: #ffffff;
      text-align: center;
      line-height: 35px;
      background: #5ad3cd;
      top: 0;
      &.disabled {
        background: #cccccc;
        color: #999999;
      }
    }
  }
}
</style>
